import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { MatSnackBar } from "@angular/material";
import { Router } from "@angular/router";
import { UserSetup } from "src/app/core/model/v2/practitioner/UserSetup";
import { UserService } from "src/app/core/services/v2/user.service";
import { WindowLoaderService } from "src/app/shared/components/window-loader/window-loader.service";
import { NotificationService } from "src/app/shared/notification-center/notification.service";

@Component({
  selector: "app-profile-summary-table",
  templateUrl: "./profile-summary-table.component.html",
  styleUrls: ["./profile-summary-table.component.scss"],
})
export class ProfileSummaryTableComponent implements OnInit {
  @Input() dataSource: UserSetup[];
  @Input() tabName;
  @Input() selectedHealthSystem;
  @Output() editItem: EventEmitter<UserSetup> = new EventEmitter();
  @Output() deleteItem: EventEmitter<UserSetup> = new EventEmitter();
  checked = true;
  disabled = false;
  displayedColumns: string[];

  constructor(
    private router: Router,
    private userService: UserService,
    private loaderService: WindowLoaderService,
    private notificationService: NotificationService,
    private _matSnackBar: MatSnackBar
  ) {}

  ngOnInit() {
    this.setColumns();
  }
  ngOnChanges() {
    let hsId = this.selectedHealthSystem != undefined ? this.selectedHealthSystem.id : 0;
  }

  setColumns() {
    if (this.tabName === "staff") {
      this.displayedColumns = [
        "name",
        "role",
        "active",
        "globalAdministrator",
        "actions",
      ];
    } else
      this.displayedColumns = [
        "name",
        "npi",
        "specialty",
        "specialization",
        // "role",
        "active",
        "globalAdministrator",
        "actions",
      ];
  }

  editItemClick(item: UserSetup): void {
    this.editItem.emit(item);
  }

  deleteItemClick(item: UserSetup): void {
    this.deleteItem.emit(item);
  }

  private toogleUserIsAdmin(item: UserSetup) {
    this.loaderService.show();
    this.userService.toggleIsGlobalAdministratorFlag(item.id).subscribe(
      (result) => {
        if (result.resultStatus.isSuccess) {
          item.isGlobalAdministrator = result.result;
        }
      },
      (error) => {
        this.loaderService.hide();
        console.error(error);
        this._matSnackBar.open(error.error.message, "Ok");
      },
      () => this.loaderService.hide()
    );
  }

  toogleIsAdmin(item: UserSetup) {
    const giveOrREmove = item.isGlobalAdministrator ? "remove" : "give";

    this.notificationService
      .confirmation(
        "Confirmation",
        `Are you sure you want to ${giveOrREmove} ${item.name} Global Administrator status ?`,
        "No",
        "Yes"
      )
      .subscribe((_) => this.toogleUserIsAdmin(item));

    // this.toogleUserIsAdmin(item);
  }

  redirectToProfile(element) {
    this.router.navigate(["/physician/profile/profilelocation/" + this.selectedHealthSystem.id, { id: element.practitioner.id, src: "overview", hsid: this.selectedHealthSystem.id }]);
    //this.router.navigate([
    //  "/physician/profile",
    //  { id: element.practitioner.id ,
    //    src: "summary",
    //    hsid: this.selectedHealthSystem.id
    //  }     
    //]);
  }
}
